declare namespace Serenity {
    interface DataChangeInfo {
        type: string;
        entityId: any;
        entity: any;
    }
}